import { render, staticRenderFns } from "./SubPackageContent.vue?vue&type=template&id=055b95e6&"
import script from "./SubPackageContent.vue?vue&type=script&lang=js&"
export * from "./SubPackageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports